import { GenericBanner, useDeviceTypes } from "halifax";
import React, { ReactElement, useContext } from "react";
import { RouterProps } from "react-router-dom";
import { B2B_PORTAL_BANNER_CONTAINER_ID, CustomerAccountRole } from "redmond";
import {
  getConfigTenant,
  isCorpTenant,
  REWARDS_BANNER_TEXT,
  useIsTravelApp,
} from "@capone/common";

import { ClientContext } from "../../../../App";
import {
  PATH_VACATION_RENTALS_BOOK,
  PATH_VACATION_RENTALS_BOOK_CONFIRMATION,
  PATH_VACATION_RENTALS_SHOP,
} from "../../../../utils/paths";
import { RewardsBannerConnectorProps } from "./container";
import { VACATION_RENTALS_REWARDS_DISABLED_BANNER_TEXT } from "./constants";

export interface IRewardsBannerProps
  extends RewardsBannerConnectorProps,
    RouterProps {}

export const RewardsBanner = (props: IRewardsBannerProps) => {
  const { history, largestValueAccount: account } = props;
  const { sessionInfo, isRewardsDisabled } = useContext(ClientContext);
  const firstName = sessionInfo?.userInfo?.firstName || "";

  const { matchesMobile } = useDeviceTypes();

  let contentText: string | ReactElement = "";

  const {
    earn,
    lastFour = "",
    productDisplayName: productId = "",
    rewardsBalance,
  } = account || {};
  const { currency, currencyDescription } = rewardsBalance || {};
  const {
    hotelsMultiplier = "",
    homesMultiplier = "",
    flightsMultiplier = "",
    carsMultiplier = "",
  } = earn || {};

  const tenant = getConfigTenant();
  const isCorp = isCorpTenant(tenant);

  const { isTravelApp } = useIsTravelApp();

  const isOnVacationRentalsBannerPath = [
    PATH_VACATION_RENTALS_SHOP.slice(0, -1),
    PATH_VACATION_RENTALS_SHOP,
    PATH_VACATION_RENTALS_BOOK.slice(0, -1),
    PATH_VACATION_RENTALS_BOOK,
    PATH_VACATION_RENTALS_BOOK_CONFIRMATION.slice(0, -1),
    PATH_VACATION_RENTALS_BOOK_CONFIRMATION,
  ].includes(history.location.pathname);

  if (
    isRewardsDisabled &&
    !isCorp &&
    !isTravelApp &&
    isOnVacationRentalsBannerPath
  ) {
    return (
      <GenericBanner
        className="rewards-banner-root"
        content={VACATION_RENTALS_REWARDS_DISABLED_BANNER_TEXT}
        containerId={B2B_PORTAL_BANNER_CONTAINER_ID}
        isMobile={matchesMobile}
      />
    );
  }

  if (!account || !account?.earn || isCorp || isTravelApp) {
    return null;
  }

  switch (history.location.pathname) {
    case PATH_VACATION_RENTALS_SHOP.slice(0, -1):
    case PATH_VACATION_RENTALS_SHOP:
    case PATH_VACATION_RENTALS_BOOK.slice(0, -1):
    case PATH_VACATION_RENTALS_BOOK:
    case PATH_VACATION_RENTALS_BOOK_CONFIRMATION.slice(0, -1):
    case PATH_VACATION_RENTALS_BOOK_CONFIRMATION:
      contentText = REWARDS_BANNER_TEXT({
        firstName,
        earnRate: hotelsMultiplier,
        homeEarnRate: homesMultiplier,
        flightEarnRate: flightsMultiplier,
        carEarnRate: carsMultiplier,
        productId,
        lastFour,
        currency: currencyDescription || currency || "",
        isPrimary: account.customerAccountRole === CustomerAccountRole.Primary,
        tenant,
      });
      break;
    default:
      contentText = "";
  }

  if (!contentText) {
    return null;
  }

  return (
    <GenericBanner
      className="rewards-banner-root"
      content={contentText}
      containerId={B2B_PORTAL_BANNER_CONTAINER_ID}
      isMobile={matchesMobile}
    />
  );
};
